module.exports = __webpack_public_path__ + "static/img/a050.aa78e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a050.jpg
// module id = NYut
// module chunks = 0